export default __webpack_public_path__ + "static/dealer-contact-img~TbauxtDV-8679e683ee68113f6aebabee99dfe214.jpg";